import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
const API_URL = environment.apiUrl + 'product';
const OPENCART_API = environment.openCartApiUrl;
@Injectable({
    providedIn: 'root'
})
export class ProductService {
    authtoken: string;
    private httpOptions;
    constructor(private http: HttpClient, private token: TokenStorageService) {
        this.authtoken = this.token.getToken();
        this.httpOptions = {
            headers: new HttpHeaders()
                .set("Content-Type", "application/json")
                .set('Authorization', `Bearer ${this.authtoken}`)
        };
    }
    getProductList(query): Observable<any> {
        return this.http.get(API_URL + query);
    }
    getProductDetails(id): Observable<any> {
        return this.http.get(API_URL + '/' + id);
    }
    updateProduct(id, userdata): Observable<any> {
        return this.http.put(API_URL + '/' + id, userdata);
    }
    addProduct(productdata): Observable<any> {
        return this.http.post(API_URL, productdata);
    }
    uploadProductCsv(csvData): Observable<any> {
        return this.http.post(API_URL + '/uploadCSV', csvData);
    }
    uploadProductImages(imagesData): Observable<any> {
        return this.http.post(API_URL + '/uploadImages', imagesData);
    }
    getOpenCartTplShopProducts(query:string) {
        return this.http.get(OPENCART_API + '?' + query);
    } 
}